import { render, staticRenderFns } from "./question-fill.vue?vue&type=template&id=0241f9c4&scoped=true"
import script from "./question-fill.vue?vue&type=script&lang=ts"
export * from "./question-fill.vue?vue&type=script&lang=ts"
import style0 from "./question-fill.vue?vue&type=style&index=0&id=0241f9c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0241f9c4",
  null
  
)

export default component.exports